import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { SearchContext, NavBarContext } from "../../App";

// import useFetchTags from '../../hooks/search/useFetchTags';
import classes from "./TopPage.module.css";

import PhoneSearch from "./PhoneSearch";

import SearchInputs from "./inputSearch/SearchInputs";
import SearchOptions from "./inputSearch/SearchOptions";
// import downArrow from "../../public/HomepageVectors/downArrow.png";
import backgroundImage from "../../public/HomepagePhotos/Bildergruppen.png";
import tabletBackgroundImage from "../../public/HomepagePhotos/BildergruppenTablet.png";
import phoneBackground from "../../public/HomepagePhotos/phoneBackgroundOpacity.png";

// import { fi } from "date-fns/locale";

export const TopPage = () => {
  const navigate = useNavigate();
  const { showSignIn, showRegister } = useContext(NavBarContext);

  const {
    searchFields,
    setSearchFields,
    options,
    setOptions,
    activeInput,
    setActiveInput,
    setIsPhoneSearch,
    updateSearchField,
    filteredActivities,
    filteredLocations,
    setFilteredLocations,
    selectLocation
  } = useContext(SearchContext);

  const [isPhoneSize, setIsPhoneSize] = useState(false);
  const [isPhoneSearchOpen, setIsPhoneSearchOpen] = useState(false);

  // Backend tag search disabled — static suggestions from searchStore / activitySearchOptions
  // const {
  //   tags: apolloTags,
  //   loading: tagsLoading,
  //   error: tagsError,
  //   searchTags,
  // } = useFetchTags();

  const navigateToAllStudios = () => {
    setSearchFields({
      activity: '',
      location: '',
      locationPlaceId: '',
      date: '',
      guest: '',
      price: '',
      studioTag: '',
      groupSize: '',
      bounds: null
    });
    navigate(`/search`, { replace: false });
  };

  // useEffect(() => {
  //   if (searchFields.activity) {
  //     searchTags(searchFields.activity);
  //   }
  // }, [searchFields.activity, searchTags]);

  // useEffect(() => {
  //   if (apolloTags && !tagsLoading) {
  //     const formattedTags = apolloTags?.map(tag => ({
  //       id: tag?.id,
  //       name: tag?.name,
  //     }));
  //     setFilteredActivities(formattedTags);
  //   }
  // }, [apolloTags, tagsLoading, setFilteredActivities]);

  useEffect(() => {
    const handleResize = () => {
      setIsPhoneSize(window.innerWidth <= 742);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const clearStaleScrollLock = () => {
      // iOS Safari can restore pages from bfcache with stale lock styles.
      if (isPhoneSearchOpen || showSignIn || showRegister) return;

      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.body.style.touchAction = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.position = '';
      document.documentElement.style.height = '';
      document.documentElement.style.touchAction = '';
    };

    clearStaleScrollLock();
    window.addEventListener('pageshow', clearStaleScrollLock);

    return () => {
      window.removeEventListener('pageshow', clearStaleScrollLock);
    };
  }, [isPhoneSearchOpen, showSignIn, showRegister]);

  const handlePhoneSearchOpen = () => {
    setIsPhoneSearchOpen(true);
  };

  const handlePhoneSearchClose = () => {
    setIsPhoneSearchOpen(false);
  };

  const handleLocationSelect = (locationId) => {
    selectLocation(locationId);
  };

  return (
    <div className={classes.container}>
      <div 
        className={classes.backgroundImageContainer}
        style={{
          width: showSignIn || showRegister ? 'calc(100% - 15px)' : '100%',
        }}
      >
        <img src={backgroundImage} alt="Background Studios" />
      </div>
      <div className={classes.tabletBackgroundImageContainer}>
        <img src={tabletBackgroundImage} alt="Background Studios" />
      </div>
      <div className={classes.phoneBackgroundImageContainer}>
        <img src={phoneBackground} alt="Background Studios" />
      </div>
      <div className={classes.centerContainer}>
        <div className={classes.titleContainer}>
          <h1>Deine Idee.</h1>
          <h1>Dein Studio.</h1>
        </div>
        <div className={classes.textContainer}>
          <h3>Buche und vermiete ganz einfach dein</h3>
          <h3>Studio im Bereich Musik, Foto und Video.</h3>
        </div>
          <SearchContext.Provider
            value={{
              searchFields,
              setSearchFields,
              options,
              setOptions,
              activeInput,
              setActiveInput,
              setIsPhoneSearch,
              updateSearchField,
              filteredActivities,
              filteredLocations,
              setFilteredLocations,
              selectLocation
            }}
          >
            <SearchInputs />
            <SearchOptions />
        </SearchContext.Provider>
      </div>
      <div className={classes.phoneContainer}>
        <div className={classes.stuPhoneLogo}>
          <svg xmlns="http://www.w3.org/2000/svg" width="121" height="42" viewBox="0 0 121 42" fill="none">
            <g clipPath="url(#clip0_2984_2220)">
              <path d="M22.2559 21.6638L19.0953 21.3984C11.2749 20.7654 8.64113 19.9487 8.64113 18.1723C8.64113 16.3959 11.9638 15.4159 18.8117 15.4159C26.0445 15.4159 28.962 16.3755 29.5698 18.9482L29.6711 19.3566H37.613L37.5319 18.7849C36.7418 12.0061 30.7043 8.71875 19.0953 8.71875C7.4863 8.71875 1.52985 11.9448 1.52985 18.2744C1.52985 24.0731 6.29096 26.8704 18.0013 27.9322L20.8377 28.1976C28.5973 28.8714 31.4742 29.8923 31.4742 31.9341C31.4742 34.1597 27.9287 35.3031 20.9187 35.3031C12.9768 35.3031 8.92477 33.8126 8.53983 30.7294L8.47905 30.2802H0.537109V30.8315C0.90179 38.2433 7.54708 42.0002 20.3109 42.0002C33.0747 42.0002 38.6057 38.4883 38.6057 31.5666C38.6057 25.4003 34.027 22.6235 22.2559 21.6638Z" fill="white" />
              <path d="M97.3999 9.73943V22.9703C97.3999 30.3821 92.5577 34.9762 84.7779 34.9762C77.464 34.9762 74.6073 31.6889 74.6073 23.2358V9.73943H50.0522V0L42.7383 3.10355V30.9947C42.7383 38.6923 46.4256 41.9796 55.0766 41.9796C58.0954 41.9796 60.9926 41.4691 63.444 40.9587L63.8492 40.877V34.3228L63.2414 34.4453C60.0606 35.0987 58.6424 35.3437 56.3733 35.3437C52.1795 35.3437 50.0522 34.3432 50.0522 28.8508V15.8649H70.92L67.0706 18.8051V25.6247C67.0706 36.7934 71.7709 41.9796 81.8402 41.9796C88.3436 41.9796 93.6923 39.7132 97.3999 35.3845V40.9587H104.937V9.73943H97.3999Z" fill="white" />
              <path d="M115.492 18.5455C118.228 18.5455 120.447 16.4086 120.447 13.7727C120.447 11.1368 118.228 9 115.492 9C112.755 9 110.537 11.1368 110.537 13.7727C110.537 16.4086 112.755 18.5455 115.492 18.5455Z" fill="#FF003E" />
            </g>
            <defs>
              <clipPath id="clip0_2984_2220">
                <rect width="120" height="42" fill="white" transform="translate(0.537109)" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className={classes.phoneTitles}>
          <h1>Deine Idee.</h1>
          <h1>Dein Studio.</h1>
        </div>
        <div className={classes.phoneSearchContainer}>
          <div className={classes.phoneSearchIconContainer}>
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <path d="M14.6218 12.3972C15.6333 11.0611 16.1942 9.41345 16.1942 7.72566C16.1942 3.466 12.7589 0 8.5424 0C4.32591 0 0.890625 3.466 0.890625 7.72566C0.890625 11.9853 4.31589 15.4413 8.5424 15.4413C10.215 15.4413 11.8475 14.8887 13.1795 13.864L18.9584 19.5L20.3906 18.0232L14.6218 12.3972ZM8.78277 13.3818H8.5424C5.44764 13.3818 2.93377 10.84 2.93377 7.71561C2.93377 4.59119 5.44764 2.06955 8.5424 2.06955C11.6372 2.06955 14.141 4.60124 14.141 7.72566C14.141 10.8501 11.7874 13.2512 8.78277 13.3818Z" fill="#77808A" />
            </svg>
          </div>
          <button onClick={handlePhoneSearchOpen}>
            Aktivität oder Studio suchen
          </button>
        </div>
      </div>
      <div className={classes.downArrowLink} onClick={navigateToAllStudios}>
        <div className={classes.downArrowContainer}>
          <span>Alle Studios entdecken</span>
          {/* <img alt="arrow down" src={downArrow} /> */}
        </div>
      </div>
      <SearchContext.Provider
        value={{
          searchFields,
          setSearchFields,
          options,
          setOptions,
          activeInput,
          setActiveInput,
          setIsPhoneSearch,
          updateSearchField,
          filteredActivities,
          filteredLocations,
          setFilteredLocations,
          onLocationSelect: handleLocationSelect,
          selectLocation
        }}
      >
        {isPhoneSize && <PhoneSearch isOpen={isPhoneSearchOpen} close={handlePhoneSearchClose} />}
      </SearchContext.Provider>
    </div>
  );
};

export default TopPage;
